module.exports = __webpack_public_path__ + "static/media/gif2.20c24764.gif";